import { render, staticRenderFns } from "./RecordVideoAnswer.vue?vue&type=template&id=78f8232b"
import script from "./RecordVideoAnswer.vue?vue&type=script&lang=js"
export * from "./RecordVideoAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports